export const logsSearchSchema = [

{
    id:1,
    name:'username',
    type:'text',
    labelTitle:'Nombre de usuario'
},

{
    id:2,
    name:'transactionType',
    select:'true',
    labelTitle:'Tipo de Transacción'
},
]